import {
    Button,
    ButtonBase,
    ListItem,
    styled,
    Typography,
} from "@mui/material";
import { MODAL_TITLE_STYLES } from "../../../../styles";

export const ServiceModalInnerContainerStyles = {
    overflowY: "unset",
    height: "unset",
    maxHeight: "70vh",
    width: "90%",
    maxWidth: "500px",
    borderRadius: "12px",
    "& .MuiDialogContent-root": {
        padding: "12px 0",
    },
    "& .MuiDialogActions-root": {
        padding: "10px 16px",
        margin: 0,
        minHeight: "unset",
    },
    "& .MuiDialogTitle-root": {
        padding: "12px 16px 0 16px",
        margin: 0,
        ...MODAL_TITLE_STYLES,
        borderBottom: "none",
        "p:first-of-type": { ...MODAL_TITLE_STYLES },
    },
};

export const OptionContainer = styled(Button, {
    shouldForwardProp: (prop) => prop !== "textColor",
})<{ textColor?: string }>(({ textColor }) => ({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    fontWeight: "400",
    color: textColor ?? "var(--community-color-primary-text)",
    fontSize: "16px",
    textTransform: "initial",
    padding: "12px 16px",
    width: "100%",
    "&:hover": {
        backgroundColor: "--community-color-transparent-black-05",
    },
}));

export const OptionIcon = styled("div")({
    width: "30px",
    height: "24px",
    marginRight: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    svg: {
        height: "24px",
        width: "24px",
    },
});

export const OptionHeadline = styled("div")({
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

export const ContentTypography = styled(Typography)({
    padding: "0 16px",
});

export const ReportingReasonsContainer = styled("div")({
    display: "flex",
    width: "100%",
    flexDirection: "column",
});

export const ReasonListItemButtonBase = styled(ButtonBase)({
    display: "flex",
    margin: 0,
    width: "100%",
});

export const ReasonListItem = styled(ListItem)({
    display: "flex",
    margin: 0,
    width: "100%",
    justifyContent: "space-between",
    padding: "12px 16px",
    color: "var(--community-color-primary-text)",
    "&:hover": {
        backgroundColor: "var(--community-color-transparent-black-05)",
    },
});
